import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { RoleTypes } from '../../shared/models/user';
import { catchError, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserType } from '../../shared/models/user-type';
import { AuthState } from '../reducers/shell.reducer';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AccountService = /** @class */ (function () {
    function AccountService(http) {
        this.http = http;
    }
    AccountService.prototype.loggedIn = function () {
        var requestUrl = baseApiUrl + "/loggedIn";
        return this.http.get(requestUrl)
            .pipe(map(function (response) {
            if (response.success)
                return true;
            else
                return false;
        }));
    };
    AccountService.prototype.createUserStateFromToken = function (token) {
        var helper = new JwtHelperService();
        var decodedToken = helper.decodeToken(token);
        var roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || [];
        var userType;
        if (roles.indexOf(RoleTypes.adminRole) > -1) {
            userType = UserType.Administrative;
        }
        else {
            userType = UserType.Guest;
        }
        var payload = {
            authenticated: true,
            token: decodedToken,
            user: {
                email: decodedToken['Email'],
                fullName: decodedToken['FullName'],
                useName: decodedToken["UserName"],
                userId: decodedToken["UserId"],
                userType: userType,
                lastLogin: decodedToken["LastLogin"],
                isAdmin: roles && roles.indexOf(RoleTypes.adminRole) > -1,
                roles: roles instanceof Array ? roles : [roles]
            },
            sessionExtended: false
        };
        return payload;
    };
    AccountService.prototype.getUserFromToken = function () {
        var _this = this;
        var requestUrl = baseUrl + "/account/gettoken";
        console.log("Account service getToken called");
        return this.http.get(requestUrl)
            .pipe(map(function (token) {
            return _this.createUserStateFromToken(token.token);
        }), catchError(function (httpError) { return _this.handleError(httpError); }));
    };
    AccountService.prototype.getModalLoginForm = function () {
        var requestUrl = baseUrl + "account/login?showModal=true";
        var getOptions = { responseType: 'text' };
        return this.http.get(requestUrl, getOptions)
            .pipe(map(function (resp) {
            return resp;
        }));
    };
    AccountService.prototype.login = function (username, password) {
        var _this = this;
        var requestUrl = baseUrl + "/account/LoginAsync?showmodal=true";
        var params = { UserName: username, Password: password, apiLogin: '1' };
        return this.http.post(requestUrl, params)
            .pipe(map(function (token) {
            return true;
        }), catchError(function (httpError) { return _this.handleError(httpError); }));
    };
    AccountService.prototype.handleError = function (httpError) {
        var errorMessage = "An unknown error occurred while submitting the request";
        if (httpError.error && httpError.error.message) {
            errorMessage = httpError.error.message;
        }
        //core.pageBanner.loadResponse(errorMessage, { title: "Error occurred", type: core.pageBanner.bannerTypes.error });
        return throwError(httpError);
    };
    AccountService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.ɵɵinject(i1.HttpClient)); }, token: AccountService, providedIn: "root" });
    return AccountService;
}());
export { AccountService };
